/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent, memo } from "react";

type Props = {
  className?: string;
};

const Logo: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={clsx("block aspect-square", className)}
    viewBox="0 0 131.233 131.233"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#0671d8">
      <path d="M16.933 0C7.581 0 0 7.581 0 16.933V114.3c0 9.351 7.581 16.933 16.933 16.933H114.3c9.351 0 16.933-7.582 16.933-16.933V16.933C131.232 7.581 123.65 0 114.299 0zm0 8.467H114.3a8.467 8.467 0 0 1 8.466 8.466V114.3a8.467 8.467 0 0 1-8.466 8.466H16.933a8.467 8.467 0 0 1-8.466-8.466V16.933a8.467 8.467 0 0 1 8.466-8.466z" />
      <path d="M59.266 88.899v8.466h46.566V88.9zM59.266 33.866v45.508h9.525V42.333h9.525v37.041h9.525V42.333h6.35a3.175 3.175 0 0 1 3.174 3.175v33.866h9.525V44.449c0-5.845-4.738-10.583-10.583-10.583zM34.925 33.866c-5.845 0-10.584 4.738-10.584 10.583v24.342c0 5.845 4.739 10.583 10.584 10.583h8.466v2.117c0 4.091-3.79 7.408-8.466 7.408h-5.292v8.466h5.292c9.936 0 17.991-7.107 17.991-15.874V33.866zm2.116 8.467h6.35v28.574h-6.35a3.175 3.175 0 0 1-3.175-3.175V45.508a3.175 3.175 0 0 1 3.175-3.175z" />
    </g>
  </svg>
);

export const GMLogo = memo(Logo);
